import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import { useAppDispatch } from 'src/hooks';
import { getMarketMaturityData, getProductFeatureList } from '../../../../store/landing-slice';
import Storage from 'src/utils/storage/storage';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import FeaturesMap from './features-map';
import ReleaseNotes from './release-notes';
import DataMaturity from './data-maturity';
import './product-info.scss';

interface TabData {
  name: string;
  alias: string;
  icon: string;
}

export default function ProductInfoComponent() {
  const appDispatch = useAppDispatch();
  // Getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();
  // Fetch product feature list 
  useEffect(() => {
    appDispatch(getProductFeatureList({ sourceId }));
    appDispatch(getMarketMaturityData({ sourceId }))
  }, []);

  const productInfoData: TabData[] = [
    // { name: 'features_map', alias: 'Features Map', icon: '/static/images/features-map-icon.svg' },
    { name: 'release_notes', alias: 'Release Notes', icon: '/static/images/release-notes-icon.svg' },
    // { name: 'data_maturity', alias: 'Data Maturity', icon: '/static/images/data-maturity-icon.svg' }
  ];

  const [selectedSubTab, setSelectedSubTab] = useState<string>('release_notes');
  const [cardsData, setCardsData] = useState<TabData>(() => productInfoData[0]);

  // Handler for toggling tabs
  const handleToggleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedSubTab('release_notes');
    // Update the cards data as per active tab
    const newActiveTabCardsData = productInfoData.find((ele) => ele.name === newValue);
    if (newActiveTabCardsData) {
      setCardsData(newActiveTabCardsData);
    }
  };

  // Component to render tab label with icon
  const RenderLabelWithIcon = ({ path, text }: { path: string; text: string }) => (
    <div className='label-with-icon'>
      <img src={path} alt={text} />
      <span style={{ marginLeft: '6px' }}>{text}</span>
    </div>
  );

  // Component for rendering the tabs
  const renderTabs = (tabsData: TabData[]) => (
    <TabContext value={selectedSubTab}>
      <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
        <TabList onChange={handleToggleChange} aria-label='product-info-tabs'>
          {tabsData.map((ele, index) => (
            <Tab
              key={ele.name} // Adding a unique key for each Tab
              label={<RenderLabelWithIcon path={ele.icon} text={ele.alias} />}
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              sx={{ textTransform: 'none' }}
              value={ele.name}
            />
          ))}
        </TabList>
      </Box>
    </TabContext>
  );

  // Component to render content based on selected tab
  const RenderContent = ({ selectedTab }: { selectedTab: string }) => {
    switch (selectedTab) {
      case 'features_map':
        return <FeaturesMap />;
      case 'release_notes':
        return <ReleaseNotes />;
      case 'data_maturity':
        return <DataMaturity />;
      default:
        return null;
    }
  };

  return (
    <Grid container className='product-info-container'>
      <div className='tabs-holder'>{renderTabs(productInfoData)}</div>
      <div className={selectedSubTab === 'features_map' ? 'background-color-addition' : 'cards-container'}>
        <Grid container spacing={1}>
          {/* <ReleaseNotes /> */}
          <RenderContent selectedTab={'release_notes'} />
        </Grid>
      </div>
    </Grid>
  );
}
